import api from '@pray/shared/utils/api';

/* eslint-disable camelcase */
export type YouTubeConnectionStatusData = {
  is_connected: boolean;
  profile_handle?: string;
  channel_id?: string;
};

export type YouTubeConnectionStatusResponse = {
  data: YouTubeConnectionStatusData;
};
/* eslint-enable camelcase */

export type GetYouTubeConnectionStatusProps = {
  artistId: string;
};

/**
 * Fetches the current YouTube connection status and channel details
 */
export async function getYouTubeConnectionStatus({
  artistId,
}: GetYouTubeConnectionStatusProps): Promise<YouTubeConnectionStatusData> {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/socials/youtube/connection-status`;
  const response = await api.executeGetRequest<YouTubeConnectionStatusResponse>(url);

  return response.data.data;
}
